// src/helpers/rutaDashboardControl.js

import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  "https://backre-miami.us-3.evennode.com";

const BASE_URL =
  String(
    RAW_BASE_URL
  ).replace(/\/+$/, "");

const API =
  axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
  });

const authConfig = () => ({
  headers: {
    token:
      localStorage.getItem(
        "token"
      ) || "",
  },
});

export const getPagosDashboardControl =
  async (
    ventaIds = []
  ) => {
    const response =
      await API.post(
        "/pagoventas/dashboard-control",
        {
          ventaIds,
        },
        authConfig()
      );

    return response.data;
  };